/**
 * AssetTypeService
 * Service for AssetType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for AssetType CRUD operations */
export class AssetTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetTypeService.DEFAULT_SERVICE_PATH,
            basePath: AssetTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AssetTypeService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetTypeService.BASE_PATH = 'api/asset-types';
//# sourceMappingURL=AssetTypeService.js.map